module.exports = __webpack_public_path__ + "img/background007.jpg";